<template>
  <div class="yxqn-switch-content">
    <div
      class="yxqn-switch-container"
      :style="yxqnSwitchContainerStyle"
      :class="{on:checked}">
      <div class="yxqn-switch-btn" ref="switchBtn"
        :style="yxqnSwitchBtnStyle"></div>
    </div>
    <input
      class="yxqn-switch-input"
      type="checkbox"
      :checked="checked"
      @change="handleChangeSwitch"
      ref="input"
      :id="id"
      :name="name"
    >
  </div>
</template>

<script>
export default {
  name: 'yxqnSwitch',
  props: {
    model: {
      prop: 'value',
      event: 'change'
    },
    activeColor: {
      type: String,
      default: '#409EFF'
    },
    inactiveColor: {
      type: String,
      default: '#EBEEF5'
    },
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    width: {
      type: [String],
      default: '40px'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    id: String
  },
  data () {
    return {}
  },
  computed: {
    yxqnSwitchContainerStyle () {
      return `
        background: ${this.checked ? this.activeColor : this.inactiveColor};
        border-color:${this.checked ? this.activeColor : '#DCDFE6'};
        width:${this.width}
      `
    },
    yxqnSwitchBtnStyle () {
      return `
        left:${this.checked ? 'calc(100% - 20px)' : ''}
      `
    },
    checked () {
      return this.value
    }
  },
  methods: {
    handleChangeSwitch (status) {
      this.$emit('change', this.$refs.input.checked)
    }
  },
  watch: {
    checked () {
      this.$refs.input.checked = this.checked
    }
  }
}
</script>

<style scoped lang="less">
  @import "../../styles/customMixin.less";

  .yxqn-switch-input {
    width: 100%;
    height: 100%;
    opacity: 0;
    position: absolute;
    cursor: pointer;
  }

  .yxqn-switch-content {
    .flex-column-normal();
    position: relative;
    height: 20px;
    justify-content: center;
  }

  .yxqn-switch-container {
    height: 10px;
    width: 40px;
    background: #EBEEF5;
    border-radius: 5px;
    position: relative;
    cursor: pointer;
    box-sizing: border-box;
    border: 1px solid #DCDFE6;
    transition: .3s;
    .yxqn-switch-btn {
      transition: .15s;
      position: absolute;
      width: 20px;
      height: 20px;
      top: -6px;
      left: -1px;
      border-radius: 10px;
      background: #ffffff;
      box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
    }
  }
</style>
